import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ProjectService } from "../services";
import { actions } from "../store/reducers/project";

export const getSources = async (projectData) => {
  if (!projectData || !projectData.id) {
    return [];
  }
  try {
    const { data } = await ProjectService.getSource(projectData.id);
    if (data && Array.isArray(data)) {
      return data;
    }

    return [];
  } catch (err) {
    console.log(err);
    return [];
  }
}

export const useGetSources = ({ projectData }) => {
  const { sources } = useSelector((state) => state.project);
  const dispatch = useDispatch();

  useEffect(() => {
    if (projectData && projectData.id) {
      const _fetch = async () => {
        const _data = await getSources(projectData);
        dispatch(actions.ChangeSources(_data));
      };

      _fetch();
    }
  }, [projectData]);

  return { sources };
};
